(() => {
	const init = () => {
		const modules = [...document.querySelectorAll('.redaxo section.spezialindex')]

		if (!modules.length) return

		let framePending = false

		const updateIndex = () => {
			const threshold = window.scrollY + window.innerHeight * 0.65
			let activeContent = null
			let activeTop = -Infinity

			modules.forEach(module => {
				const links = [...module.querySelectorAll('.index a[href^="#"]')]

				module.querySelectorAll('.content .text[id]').forEach(content => {
					const link = links.find(item => item.hash === `#${content.id}`)

					if (!link) return

					const contentTop = content.getBoundingClientRect().top + window.scrollY
					const reached = threshold > contentTop

					link.closest('li')?.classList.toggle('reached', reached)

					if (reached && contentTop > activeTop) {
						activeContent = content
						activeTop = contentTop
					}
				})
			})

			if (activeContent && window.location.hash !== `#${activeContent.id}`) {
				history.replaceState(null, '', `#${activeContent.id}`)
			}

			framePending = false
		}

		const requestUpdate = () => {
			if (framePending) return

			framePending = true
			window.requestAnimationFrame(updateIndex)
		}

		modules.forEach(module => {
			module.querySelectorAll('.index a[href^="#"]').forEach(link => {
				link.addEventListener('click', event => {
					const target = module.querySelector(link.hash)

					if (!target) return

					event.preventDefault()
					target.scrollIntoView({ behavior: 'smooth', block: 'start' })
					history.pushState(null, '', link.hash)
				})
			})
		})

		window.addEventListener('scroll', requestUpdate, { passive: true })
		window.addEventListener('resize', requestUpdate)
		updateIndex()
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true })
	} else {
		init()
	}
})()
